import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import KVKKBanner from "@/components/KVKKBanner";

export default function Layout() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      // Delay to let the target section render before scrolling
      const id = location.hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        const y = el.getBoundingClientRect().top + window.scrollY - 88;
        window.scrollTo({ top: y, behavior: "smooth" });
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname, location.hash]);

  return (
    <div className="min-h-screen flex flex-col bg-white text-navy font-body">
      <Header />
      <main className="flex-1 pt-[72px]" data-testid="main-content">
        <Outlet />
      </main>
      <Footer />
      <KVKKBanner />
    </div>
  );
}
